import Axios, { AxiosRequestConfig } from 'axios';
import * as conf from '@/config';
import { openSnackbar } from '@/api/snackbar';
import { SnackbarProps } from '@/types/bs-types/snackbar';

const AxiosServices = Axios.create({
  baseURL: conf.API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'access-control-allow-headers': [
      'Access-Control-Allow-Origin',
      'Content-Type',
      'Authorization',
      'Origin',
      'X-Requested-With',
      'Accept',
      'Access-Control-Allow-Headers',
      'Access-Control-Allow-Methods'
    ]
  }
});

// ==============================|| Axios - FOR MOCK SERVICES ||============================== //

AxiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    // config.headers.ContentType = 'application/json';
    // config.headers.AccessControlAllowOrigin = '*';
    // config.headers.Accept = 'application/json';
    // config.headers.AccessControlAllowCredentials = 'true';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

AxiosServices.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    openSnackbar({
      open: true,
      message: `${error.response?.data?.error?.message ?? error.response}`,
      variant: 'alert',
      alert: {
        color: 'error'
      }
    } as SnackbarProps);

    // if (error.response.status === 401 && !window.location.href.includes('/login')) {
    //   window.location.pathname = '/maintenance/500';
    // }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default AxiosServices;

// export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
//   const [url, config] = Array.isArray(args) ? args : [args];
//   const res = await AxiosServices.get(url, { ...config });
//   return res.data;
// };

// export const fetcherPost = async (args: string | [string, AxiosRequestConfig]) => {
//   const [url, config] = Array.isArray(args) ? args : [args];

//   const res = await AxiosServices.post(url, { ...config });

//   return res.data;
// };


export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  // Check if the URL is full (starts with http/https)
  const isFullURL = /^https?:\/\//i.test(url);

  const res = await AxiosServices.get(url, {
    ...config,
    baseURL: isFullURL ? undefined : AxiosServices.defaults.baseURL // Override baseURL if a full URL is provided
  });

  return res.data;
};

export const fetcherPost = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  // Check if the URL is full (starts with http/https)
  const isFullURL = /^https?:\/\//i.test(url);

  const res = await AxiosServices.post(url, {
    ...config,
    baseURL: isFullURL ? undefined : AxiosServices.defaults.baseURL // Override baseURL if a full URL is provided
  });

  return res.data;
};